<template>
  <actions-menu v-model:dialogConsult="editRequestDialog" v-model:dialogDelete="dialog"
    v-model:dialogValidation="dialogValidation" :Id="Id" :ShowDialogEdit="false" :ShowDialogDelete="false"
    :ShowDialogValidation="IsSupplier() && !getPurchaseOrder.status" :ShowDialogConsult="true" :ShowExport="false" />

  <v-dialog v-model="editRequestDialog">
    <v-card width="1300px" class="py-2" style="border-radius: 12px">
      <v-form ref="form" lazy-validation>

        <div class="row ma-4">
          <h1>
            {{ $t("actions.consult", { itm: $t("purchaseOrder.purchaseOrder") }) }}
          </h1>
        </div>
        <div class="row ma-4">
          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.title") }}</v-card-title>
            </div>
            <div class="row">
              <v-text-field v-model="editData.title" id="Title" name="Title" maxlength="30" hide-details
                persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('purchaseOrder.title') })"
                variant="outlined" class="rounded-xl readonly-field" readonly></v-text-field>
              <span class="warningHint" id="WarningMsgReference">{{ msg.title }}</span>
            </div>
          </div>

          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.reference") }}
              </v-card-title>
            </div>
            <div class="row">
              <v-text-field v-model="editData.reference" id="reference" name="reference" maxlength="30" hide-details
                persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('purchaseOrder.reference') })
                  " variant="outlined" class="rounded-xl readonly-field" readonly></v-text-field>
              <span class="warningHint" id="WarningMsgReference">{{ msg.reference }}</span>
            </div>
          </div>

          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.supplier") }}</v-card-title>
            </div>
            <div class="row">
              <v-autocomplete id="Supplier" name="Supplier" class="pl-0 pr-6 readonly-field" variant="outlined"
                v-model="editData.IdSupplier" v-model:search="SupplierSearch" persistent-placeholder
                :placeholder="$t('placeholder.select', { itm: $t('purchaseOrder.supplier') })" :items="ListSupplier"
                item-title="brandName" item-value="id" hide-details readonly>
                <template v-slot:item="{ props, item, index }">
                  <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName">
                    {{ item.brandName }}
                  </v-list-item>
                </template>
              </v-autocomplete>
              <span class="warningHint" id="WarningMsgCompany">{{ msg.Supplier }}</span>
            </div>
          </div>

          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.devise") }}</v-card-title>
            </div>
            <div class="row">
              <v-autocomplete id="Devise" name="Devise" variant="outlined" v-model="editData.devise"
                persistent-placeholder :placeholder="$t('placeholder.select', { itm: $t('purchaseOrder.devise') })"
                :items="DeviseList" item-title="name" item-value="symbol" hide-details readonly class="readonly-field">
                <template v-slot:item="{ props, item, index }">
                  <v-list-item v-bind="props" variant="text" :id="index" :name="item.name">
                    {{ item.name }}
                  </v-list-item>
                </template>
              </v-autocomplete>
              <span class="warningHint" id="WarningMsgDevise">{{ msg.devise }}</span>
            </div>
          </div>

          <div class="col-4 justify-content-start">
            <div class="row">
              <v-card-title class="text-left">{{ $t("purchaseOrder.deliverydate") }}</v-card-title>
            </div>
            <div class="row">
              <dateField v-model="editData.expirationDate" :min-date="new Date('2000-01-01')" id="expirationDate"
                name="expirationDate" readonly class="readonly-field pe-none" />
            </div>
          </div>
          <v-divider></v-divider>
          <v-table theme="white" class="table-responsive rounded-table" style="width: 100%">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="column-title border-right">{{ $t("purchaseOrder.title") }}</th>
                  <th class="column-small  border-right">{{ $t("purchaseOrder.quantity") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.amountHT") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.tax") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.montantHT") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.montantTotal") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.Weight") }}</th>
                  <th class="border-right">{{ $t("purchaseOrder.status") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(line, index) in editData.lines" :key="index" class="border-bottom">
                  <td class="column-title border-right col-2">
                    <span>
                      {{ line.Title }}
                    </span>
                  </td>

                  <td class="column-small border-right col-2">
                    <span>
                      {{ line.Quantity }}
                    </span>
                  </td>
                  <td class="border-right col-2">
                    <span>
                      {{ formatPrice(line.Price) }}
                    </span>
                  </td>
                  <td class="column-small border-right col-2">
                    <span>
                      {{ line.Tax }} %
                    </span>
                  </td>
                  <td class="border-right col-2">
                    <span>
                      {{ formatPrice(MTHTVA[index]) }}
                    </span>
                  </td>
                  <td class="border-right col-2">
                    <span>
                      {{ formatPrice(MTTotal[index]) }}
                    </span>
                  </td>
                  <td class="column-small column-small border-right col-2">
                    <v-text-field v-model="line.Weight" id="Weight" name="Weight" maxlength="9" type="number"
                      hide-details persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('purchaseOrder.quantity') })
                        " variant="outlined" :readonly="!this.userIsSupplier && line.validationItemStatus !== 0"
                      :class="!this.userIsSupplier && line.validationItemStatus !== 0 ? 'readonly-field' : ''"></v-text-field>
                  </td>
                  <td class="align-top border-right col-2">
                    <div v-if="line.validationItemStatus === 0">
                      <v-btn v-if="IsSupplier() && this.SendForDelivery" text color="#114ef7"
                        @click="setLineAndOpenDialog(line)">
                        {{ $t('Delivery.SendForDelivery') }}
                      </v-btn>

                      <StatusButton v-else disableIcon
                        :title="this.SendForDelivery == 1 ? $t('Delivery.accepted') : $t('Delivery.notAccepted')"
                        :color="this.SendForDelivery == 1 ? '#3BBAFF' : '#BEBEBE'" :style="'#F25C5C'">
                        <template v-slot:icon>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.4"
                              d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                              fill="#FFFFFF" />
                            <path
                              d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                              fill="#FFFFFF" />
                            <path
                              d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                              fill="#FFFFFF" />
                          </svg>
                        </template>
                      </StatusButton>
                    </div>

                    <StatusButton v-else disableIcon :title="$t('Delivery.ReadyForDelivery')" :color="'#FF8934'"
                      :style="'#F25C5C'">
                      <template v-slot:icon>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                          <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                          <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                        </svg>
                      </template>
                    </StatusButton>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-table>
          <div class="col-8"></div>
          <div class="col-4 totals">
            <p class="ml-3 align-right">
              {{ $t("purchaseOrder.montantHT") }} :
              <strong>{{ formatPrice(totalAmountHT) }}</strong>
            </p>
            <div v-for="(amount, tax) in totaltaxs" :key="tax">
              <p class="align-right">
                <span>{{ $t("purchaseOrder.taxAmount") }} {{ tax }}% :
                  {{ formatPrice(amount) }}
                </span>
              </p>
            </div>
            <v-divider class="custom-divider"></v-divider>

            <p class="align-right">
              Total :
              <strong>{{ formatPrice(grandTotal) }}</strong>
            </p>
          </div>
        </div>
        <card-actions :yes="downloadPurchaseOrderPdf" v-model:no="editRequestDialog" :loader="loader" width="300px"
          :yesTitle="$t('purchaseOrder.downloadPdf')" />
      </v-form>
    </v-card>
  </v-dialog>

  <sendForDeliveryDialog v-if="dialogValidate" v-model="dialogValidate"
    @selectedLocation="(value) => IdLocation = value" @deliverySubmitted="markAsReadyForDelivery"
    @closeDialog="dialog = false" :item="selectedLineForDelivery?.Title" :loader="loader" />

  <dialogDelete v-model="showDeleteFileDialog" :yes="confirmFileDelete" :status="false" :title="editData.file
    ? editData.file.name
    : editData.type
      ? editData.title + '.' + editData.type
      : ''
    " v-model:no="showDeleteFileDialog"></dialogDelete>
  <dialogDelete :loader="buttonLoader" DialogType="Validation"
    :title="$t('purchaseOrder.validationTab.validationStatus')" :yes="ValidatePurchaseOrder"
    v-model="dialogValidation" />

</template>

<script>
import {
  isSupplier,
  EditPurchaseOrder,
  GetTaxListByCmpanyId,
  PurchaseOrderIsExistReference,
  idClient,
  ValidatePurchaseOrder,
  GetCompanyFromPurchaseOrders,
  generatePurchaseOrderPdf,
  updatePurchaseOrderItemStatus,
  isClient,
  formatPrice
} from "@/api/index";
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import deviseJson from "@/data/DevisesList.json";
import dialogDelete from "@/genericComponent/dialogDelete.vue";
import cardActions from "@/genericComponent/cardActions.vue";
import dateField from "@/genericComponent/date-field.vue";
import StatusButton from "@/genericComponent/StatusButton.vue";
import sendForDeliveryDialog from "./sendForDeliveryDialog.vue";

export default {
  components: { actionsMenu, dialogDelete, cardActions, dateField, StatusButton, sendForDeliveryDialog },
  props: [
    "idPurchaseOrder",
    "getPurchaseOrderListAfterDelete",
    "getPurchaseOrder",
    "SupplierList",
    "Id",
    "status"
  ],
  isUpdate: true,
  mounted() {
    this.LatestPurchaseOrderState = this.createPurchaseOrderObject(this.getPurchaseOrder);
    this.editData.title = this.getPurchaseOrder.title;
    this.editData.reference = this.getPurchaseOrder.reference;
    this.editData.idPurchaseOrder = this.getPurchaseOrder.idPurchaseOrder;
    this.editData.lines.title = this.getPurchaseOrder.purchaseOrderLines.title;
    this.editData.price = this.getPurchaseOrder.price;
    this.editData.devise = this.currency; //this.getPurchaseOrder.devise;
    this.editData.type = this.getPurchaseOrder.type;
    this.editData.expirationDate = this.getPurchaseOrder.expirationDate;
    this.editData.tax = this.getPurchaseOrder.tax;
    this.editData.quantity = this.getPurchaseOrder.quantity;
    this.editData.IdSupplier = this.getPurchaseOrder.supplier.id;
    this.ListSupplier = this.$props.SupplierList;
    this.SendForDelivery = this.$props.status;
  },
  data() {
    return {
      userIsSupplier: false,
      IdLocation: null,
      dialogValidate: false,
      SendForDelivery: false,
      selectedLineForDelivery: null,
      generationSuccess: false,
      yesDisable: false,
      userGenerateLoader: false,
      saveLoader: false,
      LatestPurchaseOrderState: null,
      title: this.$t("Delivery.generatePurchase"),
      generateBtnLoader: false,
      showGenerateDialog: false,
      SupplierSearch: null,
      dialog: false,
      editRequestDialog: false,
      TaxList: [],
      ListSupplier: [],
      Title: null,
      showDeleteDialog: null,
      isUpdate: false,
      loader: false,
      editData: {
        supplier: null,
        reference: "",
        title: "",
        idPurchaseOrder: "",
        devise: "",
        type: null,
        expirationDate: new Date(),
        lines: [
          {
            idPurchaseOrderline: "",
            Title: "",
            Quantity: 1,
            Price: null,
            IdSupplier: null,
            Tax: null,
            Weight: 0,
            errors: {},
          },
        ],
      },

      msg: [],
      DeviseList: deviseJson,
      dialogValidation: false,
      buttonLoader: false,
      showDeleteFileDialog: null,
    };
  },
  watch: {

    SupplierSearch(value) {
      if (this.SupplierSearch != null && this.SupplierSearch.length == 1)
        this.SupplierSearch = value.trim();
      this.GetSupplierList();
    },

    editRequestDialog(value) {
      if (value) {
        this.editData.idPurchaseOrder = this.getPurchaseOrder.idPurchaseOrder;
        this.editData.reference = this.getPurchaseOrder.reference;
        this.editData.title = this.getPurchaseOrder.title;
        this.editData.lines.price = this.getPurchaseOrder.price;
        this.editData.devise = this.currency; //this.getPurchaseOrder.devise;
        this.editData.type = this.getPurchaseOrder.type;
        this.editData.expirationDate = this.getPurchaseOrder.expirationDate;
        this.editData.tax = this.getPurchaseOrder.tax;
        this.editData.description = this.getPurchaseOrder.description;
        this.editData.quantity = this.getPurchaseOrder.quantity;
        this.editData.IdSupplier = this.getPurchaseOrder.supplier.id;
        if (this.getPurchaseOrder.purchaseOrderLines.length === 0) {
          this.editData.lines[0].Title = this.editData.title;
          this.editData.lines[0].Quantity = this.editData.quantity;
          this.editData.lines[0].Price = this.editData.price;
          this.editData.lines[0].Tax = this.editData.tax;
        } else {
          this.editData.lines = this.getPurchaseOrder.purchaseOrderLines.map((line) => ({
            idPurchaseOrderline: line.idPurchaseOrderline,
            Title: line.title,
            Quantity: line.quantity,
            Price: line.price,
            IdSupplier: line.idSupplier,
            Tax: line.tax,
            validationItemStatus: line.validationItemStatus,
            errors: {},
            Weight: line.weight,
          }));
        }
        (this.identityDocument = null),
          (this.identityDocuments = []),
          (this.editData.file = this.identityDocument ? this.identityDocument[0] : null);
        if (this.identityDocuments && this.identityDocuments.length > 0) {
          this.editData.filesToAdd = this.identityDocuments;
        } else {
          this.editData.filesToAdd = null;
        }
        this.msg = [];
      }
    },
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price)
    },
    setLineAndOpenDialog(line) {
      this.selectedLineForDelivery = line;
      this.dialogValidate = true;
    },
    IsClient() {
      return isClient();
    },
    cancelDelivery() {
      this.SendForDelivery = false;
      this.selectedLineForDelivery = null;
    },
    async markAsReadyForDelivery() {
      this.loader = true;
      try {
        if (!this.selectedLineForDelivery) {
          console.error("No selected line for delivery.");
          return;
        }

        const formData = new FormData();
        formData.append("PurchaseOrderItemId", this.selectedLineForDelivery.idPurchaseOrderline);
        formData.append("validationStatus", 1);  // 1 pour "Ready for delivery"
        formData.append("SupplierLocationId", this.IdLocation)
        formData.append("Weight", this.selectedLineForDelivery.Weight)

        updatePurchaseOrderItemStatus(formData).then(() => {
          this.ActiveSavedSnackBar()
        }).catch(() => {
          this.ActiveWarningSnackBar()
        });

        // Update the line in the lines array to ensure persistence
        const lineIndex = this.editData.lines.findIndex(line => line.idPurchaseOrderline === this.selectedLineForDelivery.idPurchaseOrderline);
        if (lineIndex !== -1) {
          this.editData.lines[lineIndex].validationItemStatus = 1;
          this.editData.lines[lineIndex].Weight = this.selectedLineForDelivery.Weight;

          // Update the parent's purchase order data
          const updatedPurchaseOrder = { ...this.getPurchaseOrder };
          const purchaseOrderLineIndex = updatedPurchaseOrder.purchaseOrderLines.findIndex(
            line => line.idPurchaseOrderline === this.selectedLineForDelivery.idPurchaseOrderline
          );

          if (purchaseOrderLineIndex !== -1) {
            updatedPurchaseOrder.purchaseOrderLines[purchaseOrderLineIndex].validationItemStatus = 1;
            updatedPurchaseOrder.purchaseOrderLines[purchaseOrderLineIndex].weight = this.selectedLineForDelivery.Weight;
            this.$emit('update:getPurchaseOrder', updatedPurchaseOrder);
          }
        }

        this.$emit("snackbarSuccess", this.$t("purchaseOrder.itemUpdated"));

        // Réinitialisez les variables
        this.dialogValidate = false;
        this.selectedLineForDelivery = null;
      } catch (error) {
        console.error("Error updating item status:", error);
        this.$emit("snackbarError", this.$t("purchaseOrder.updateFailed"));
      }
      this.loader = false;
    },

    IsSupplier() {
      this.userIsSupplier = isSupplier()
      return this.userIsSupplier;
    },
    filterInteger(index) {
      this.editData.lines[index].Quantity =
        parseInt(this.editData.lines[index].Quantity) || null;
    },

    createPurchaseOrderObject(getPurchaseOrder) {
      const lines = getPurchaseOrder.purchaseOrderLines ?? getPurchaseOrder.lines;
      return {
        supplier: getPurchaseOrder.supplier?.id ?? getPurchaseOrder.IdSupplier,
        reference: getPurchaseOrder.reference,
        title: getPurchaseOrder.title,
        devise: getPurchaseOrder.devise,
        expirationDate: getPurchaseOrder.expirationDate.split("T")[0],
        lines: lines.map((line) => ({
          Title: line.title ? line.title : line.Title,
          Quantity: line.quantity ? parseFloat(line.quantity) : parseFloat(line.Quantity),
          Price: line.price ? parseFloat(line.price) : parseFloat(line.Price),
          Tax: line.tax ? parseFloat(line.tax) : parseFloat(line.Tax),
        })),
      };
    },

    GetSupplierList() {
      GetCompanyFromPurchaseOrders(this.SupplierSearch).then((res) => {
        this.ListSupplier = res.data;
      });
    },
    removeLine(index) {
      if (this.editData.lines.length > 1) {
        this.editData.lines.splice(index, 1);
      }
    },
    confirmFileDelete() {
      delete this.editData.file,
        delete this.editData.type,
        (this.showDeleteFileDialog = false);
    },
    GetTaxListByCmpanyId(companyId) {
      GetTaxListByCmpanyId(companyId).then((res) => {
        this.TaxList = res.data;
      });
    },
    ActiveDeletedSnackBar() {
      this.getParent("MainLayout").ActiveDeletedSnackBar();
    },
    ActiveWarningSnackBar() {
      this.getParent("MainLayout").ActiveWarningSnackBar();
    },
    ActiveSavedSnackBar() {
      this.getParent("MainLayout").ActiveSavedSnackBar();
    },
    getParent(name) {
      let p = this.$parent;
      while (typeof p !== "undefined") {
        if (p.$options.name == name) {
          return p;
        } else {
          p = p.$parent;
        }
      }
      return false;
    },
    validateFormEdit() {
      EditPurchaseOrder(this.idPurchaseOrder, this.editData)
        .then((res) => {
          if (res.status == 200) {
            this.editRequestDialog = false;
            this.getPurchaseOrderListAfterDelete();
          } else {
            this.editRequestDialog = true;
          }
          this.ActiveSavedSnackBar();
        })
        .catch(() => {
          this.ActiveWarningSnackBar();
          this.showGenerateDialog = false;
          this.generateBtnLoader = false;
        })
        .finally(() => {
          this.loader = false;
        });
    },
    async IsExistReference() {
      const r = await PurchaseOrderIsExistReference(
        this.idPurchaseOrder,
        this.editData.reference
      );
      return r.data;
    },
    validateLine(line) {
      let isValid = true;
      line.errors = {};

      if (!line.Title || line.Title.length == 0) {
        line.errors["Title"] = this.$t("warningInput.isrequired", {
          itm: this.$t("purchaseOrder.title"),
        });
        isValid = false;
      }

      if (!line.Quantity || line.Quantity <= 0) {
        line.errors["Quantity"] = this.$t("warningInput.isrequired", {
          itm: this.$t("purchaseOrder.quantity"),
        });
        isValid = false;
      }

      if (!line.Price || line.Price <= 0) {
        line.errors["AmountHT"] = this.$t("warningInput.isrequired", {
          itm: this.$t("purchaseOrder.amountHT"),
        });
        isValid = false;
      }

      if (line.Tax === null || line.Tax < 0) {
        line.errors["Tax"] = this.$t("warningInput.isrequired", {
          itm: this.$t("purchaseOrder.tax"),
        });
        isValid = false;
      }

      return isValid;
    },

    async validateFormEditRequest(state) {
      if (!this.editData.reference || this.editData.reference.length == 0) {
        this.msg["reference"] = this.$t("warningInput.isrequired", {
          itm: this.$t("purchaseOrder.reference"),
        });
      } else if ((await this.IsExistReference()) == true) {
        this.msg["reference"] = this.$t("warningInput.exist", {
          itm: this.$t("purchaseOrder.reference"),
        });
      } else {
        this.msg["reference"] = "";
      }

      if (!this.editData.expirationDate || this.editData.expirationDate.length == 0) {
        this.msg["expirationDate"] = this.$t("warningInput.isrequired", {
          itm: this.$t("purchaseOrder.expirationDate"),
        });
      } else {
        this.msg["expirationDate"] = "";
      }

      if (!this.editData.title || this.editData.title.length == 0) {
        this.msg["title"] = this.$t("warningInput.isrequired", {
          itm: this.$t("purchaseOrder.title"),
        });
      } else {
        this.msg["title"] = "";
      }
      if (!this.editData.IdSupplier || this.editData.IdSupplier.length == 0) {
        this.msg["Supplier"] = this.$t("warningInput.isrequired", {
          itm: this.$t("purchaseOrder.supplier"),
        });
      } else {
        this.msg["Supplier"] = "";
      }

      let allLinesValid = true;
      for (let i = 0; i < this.editData.lines.length; i++) {
        if (!this.validateLine(this.editData.lines[i])) {
          allLinesValid = false;
        }
      }

      if (
        this.msg["title"] == "" &&
        this.msg["Supplier"] == "" &&
        this.msg["reference"] == "" &&
        // this.msg["tax"] == "" &&
        this.msg["expirationDate"] == "" &&
        // this.msg["quantity"] == "" &&
        allLinesValid
      ) {
        switch (state) {
          case "Save":
            this.editRequestDialog = false;
            this.saveLoader = true;
            this.validateFormEdit();
            break;
          case "Generate":
            this.userGenerateLoader = true;
            this.yesDisable = true;
            this.fnGenerate()
              .then(() => {
                this.generationSuccess = true;
              })
              .catch(() => { })
              .finally(() => {
                this.yesDisable = false;
                this.userGenerateLoader = false;
                setTimeout(() => {
                  this.generationSuccess = false;
                }, 2000);
              });
            break;
          case "GenerateAndSave":
            this.generateBtnLoader = true;
            this.editRequestDialog = false;
            this.fnGenerate()
              .then(() => {
                this.validateFormEdit();
              })
              .catch(() => {
                this.showGenerateDialog = false;
                this.generateBtnLoader = false;
              });
            break;
          default:
            if (this.userUpdatedFile) {
              this.loader = true;
              this.validateFormEdit();
            } else {
              if (!this.purchaseOrderState) {
                if (this.editData.type === "Gen.pdf") {
                  this.DocumentGenerated = true;
                }
                this.showGenerateDialog = true;
              } else {
                this.loader = true;
                this.validateFormEdit();
              }
            }
        }
      }
    },
    ValidatePurchaseOrder: function () {
      this.buttonLoader = true;
      ValidatePurchaseOrder(this.getPurchaseOrder.idPurchaseOrder)
        .then(() => {
          this.ActiveSavedSnackBar();
        })
        .finally(() => {
          this.dialogValidation = false;
          this.getPurchaseOrderListAfterDelete();
        });
    },
    FormatTotal(total) {
      let formattedTotal = total.toFixed(3).toString();
      if (formattedTotal.includes(".")) {
        formattedTotal = formattedTotal.replace(/\.?0+$/, "");
      }
      return formattedTotal;
    },
    CalculateTotal(Quantity, Price, Tax) {
      if (
        Quantity !== "" &&
        Quantity != null &&
        Price !== "" &&
        Price !== null &&
        Tax !== null
      ) {
        const amountTTC =
          parseFloat(Quantity) * parseFloat(Price) * (parseFloat(Tax) / 100);
        let total = parseFloat(Quantity) * parseFloat(Price) + amountTTC;
        let parts = total.toString().split(".");
        if (parts[1] && parts[1].length > 3) {
          return total.toFixed(3);
        } else {
          return total.toFixed(3);
        }
      } else {
        return null;
      }
    },
    async downloadPurchaseOrderPdf() {
      try {
        if (!this.getPurchaseOrder.idPurchaseOrder) {
          this.$toast.error(this.$t("purchaseOrder.errorNoPurchaseOrderId"));
          return;
        }

        const response = await generatePurchaseOrderPdf(this.getPurchaseOrder.idPurchaseOrder);

        // Création de l'URL Blob pour le téléchargement
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Nom du fichier
        link.setAttribute("download", `PurchaseOrder_${this.getPurchaseOrder.reference}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error downloading PurchaseOrder PDF:", error);
        this.$toast.error(this.$t("purchaseOrder.errorDownloadPdf"));
      }
    },
  },

  computed: {
    purchaseOrderState() {
      const isSame =
        JSON.stringify(this.LatestPurchaseOrderState) ===
        JSON.stringify(this.createPurchaseOrderObject(this.editData));
      return isSame;
    },

    totaltaxs() {
      const taxs = {};
      this.editData.lines.forEach((line) => {
        if (
          line.Quantity !== "" &&
          line.Quantity !== null &&
          line.Price !== "" &&
          line.Price != null &&
          line.Tax >= 0 &&
          line.Tax !== null
        ) {
          const lineTotal = parseFloat(line.Quantity) * parseFloat(line.Price);
          const taxAmount = lineTotal * (parseFloat(line.Tax) / 100);
          if (taxs[line.Tax]) {
            taxs[line.Tax] += taxAmount;
          } else {
            taxs[line.Tax] = taxAmount;
          }
        }
      });

      return taxs;
    },
    grandTotal() {
      let total = 0;
      if (Array.isArray(this.MTTotal)) {
        this.MTTotal.forEach((amount) => {
          if (amount !== null) {
            total += parseFloat(amount);
          }
        });
      }
      return total;
    },
    totalAmountHT() {
      return this.editData.lines.reduce((total, line) => {
        if (
          line.Quantity !== "" &&
          line.Quantity !== null &&
          line.Price !== "" &&
          line.Price != null
        ) {
          return total + parseFloat(line.Quantity) * parseFloat(line.Price);
        }
        return total;
      }, 0);
    },
    idClient() {
      return idClient();
    },
    MTHTVA() {
      return this.editData.lines.map((line) => {
        if (
          line.Quantity !== "" &&
          line.Quantity !== null &&
          line.Price !== "" &&
          line.Price != null
        ) {
          let total = parseFloat(line.Quantity) * parseFloat(line.Price);
          return this.FormatTotal(total);
        } else {
          return null;
        }
      });
    },

    MTTotal() {
      return this.editData.lines.map((line) => {
        return this.CalculateTotal(line.Quantity, line.Price, line.Tax);
      });
    },
    currency() {
      return window.VUE_APP_CURRENCY;
    },

  },
};
</script>
<style scoped>
h1 {
  font-family: inter;
  font-size: 18px;
  line-height: 29px;
  font-weight: 600;
  color: #0d0849;
  text-align: center;
}

.v-card-text {
  font-family: inter;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #768da9;
}

.rounded-table {
  border-radius: 10px;
}

.custom-divider {
  border-top: 1px solid;
  border-color: currentColor;
}

.border-right {
  border: 1px solid #ddd;
  text-align: center;
  border-style: dotted;
  padding: 2px 4px;
}

.totals {
  margin-top: 20px;
  /* font-weight: bold; */
}

.align-right {
  padding-right: 85px;
  text-align: right;
  position: relative;
}

.totals p {
  margin: 5px 0;
}

.align-devise {
  float: right;
  margin-left: -16px;
}

.v-card-title {
  font-family: inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #5b6d8e;
}

.textConsumptionThreshold {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #080c3e;
}

.customWarningHint {
  color: #f25c5c;
  padding: 12px 0px 12px 12px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 0px;
  display: block;
  text-align: left;
  text-wrap: nowrap;
}

.column-title {
  width: 32%;
  /* Ajustez selon vos besoins */
}

.column-small {
  width: 8%;
  /* Ajustez selon vos besoins */
}
</style>
